
// const aepCdpArchitectQ = {
//     topic: "Aep Cja Consultant",
//     questions: [
//         {
//             question: `Which of the following configurations optimizes data ingestion into Adobe Experience Platform while ensuring data integrity and performance?`,
//             choices: [
//                 "Accepting all data formats as-is to streamline the ingestion process",
//                 "Validating incoming data against XDM schemas and partitioning data loads",
//                 "Compressing data heavily before ingestion to minimize storage space",
//                 "Disabling error logging to avoid ingestion slowdowns"
//             ],
//             type: "MCQs",
//             correctAnswer: "Validating incoming data against XDM schemas and partitioning data loads"
//         },

//     ]
// }

const aepCdpArchitectQ = {
    topic: "Aep Cja Consultant",
    questions: [
        {
            question: `Which of the following configurations optimizes data ingestion into Adobe Experience Platform while ensuring data integrity and performance?`,
            choices: [
                "Accepting all data formats as-is to streamline the ingestion process",
                "Validating incoming data against XDM schemas and partitioning data loads",
                "Compressing data heavily before ingestion to minimize storage space",
                "Disabling error logging to avoid ingestion slowdowns"
            ],
            type: "MCQs",
            correctAnswer: "Validating incoming data against XDM schemas and partitioning data loads"
        },
        {
            question: "Which strategy ensures the most accurate identity resolution when unifying customer profiles in Adobe Experience Platform?",
            choices: [
                "Utilizing only deterministic matching rules",
                "Employing a combination of deterministic and probabilistic matching techniques",
                "Resolving identities manually post-ingestion",
                "Relying on first-party identifiers exclusively"
            ],
            type: "MCQs",
            correctAnswer: "Employing a combination of deterministic and probabilistic matching techniques"
        },
        {
            question: "What technique is best for managing high-volume data ingestion in Adobe Experience Platform?",
            choices: [
                "Streaming data ingestion with no pre-processing",
                "Implementing a scalable ETL pipeline with data pre-processing and transformation",
                "Ingesting all data as-is and cleaning it post-ingestion",
                "Using a single-threaded process to maintain data consistency"
            ],
            type: "MCQs",
            correctAnswer: "Implementing a scalable ETL pipeline with data pre-processing and transformation"
        },
        {
            question: "Which feature in Adobe Experience Platform is essential for automating data governance and regulatory compliance?",
            choices: [
                "Manual data tagging for compliance",
                "Automated data classification and policy enforcement using Data Governance API",
                "Relying on external compliance tools",
                "Implementing a custom compliance monitoring system"
            ],
            type: "MCQs",
            correctAnswer: "Automated data classification and policy enforcement using Data Governance API"
        },
        {
            question: "For highly granular audience segments, which approach is most effective in Adobe Experience Platform?",
            choices: [
                "Using only demographic data",
                "Combining behavioral data with predictive analytics and machine learning models",
                "Segmentation based solely on historical purchase data",
                "Creating segments based on marketer intuition"
            ],
            type: "MCQs",
            correctAnswer: "Combining behavioral data with predictive analytics and machine learning models"
        },
        {
            question: "Real-time Customer Profile Utilization",
            choices: [
                "Static profiles updated monthly",
                "Real-time event streams and behavioral data integration for dynamic updates",
                "Third-party data sources exclusively",
                "Manual profile updates based on latest interactions"
            ],
            type: "MCQs",
            correctAnswer: "Real-time event streams and behavioral data integration for dynamic updates"
        },
        {
            question: "What advanced technique should be used to integrate customer data from multiple SaaS platforms with different data models into Adobe Experience Platform?",
            choices: [
                "Point-to-point integrations for each data source",
                "Middleware layer harmonizing data into XDM schema before ingestion",
                "Loading data directly without pre-processing",
                "Custom data models for each source"
            ],
            type: "MCQs",
            correctAnswer: "Middleware layer harmonizing data into XDM schema before ingestion"
        },
        {
            question: "Which technique ensures data privacy in real-time data flows within Adobe Experience Platform?",
            choices: [
                "Encrypting data at rest but not in transit",
                "Real-time data anonymization and pseudonymization",
                "Third-party encryption tools only",
                "Disabling real-time data processing"
            ],
            type: "MCQs",
            correctAnswer: "Real-time data anonymization and pseudonymization"
        },
        {
            question: "Which advanced analytic technique allows for uncovering deep customer insights and predictive trends in Adobe Experience Platform?",
            choices: [
                "Basic descriptive statistics using Excel exports",
                "Data Science Workspace with custom machine learning models",
                "Manual analysis of raw data logs",
                "Trend analysis using built-in reporting tools"
            ],
            type: "MCQs",
            correctAnswer: "Data Science Workspace with custom machine learning models"
        },
        {
            question: "To predict customer churn using Adobe Experience Platform, which method provides the most accurate model?",
            choices: [
                "Basic linear regression on historical churn data",
                "Data Science Workspace to build and train a machine learning model using historical, behavioral, and transactional data",
                "Pre-built churn prediction models without customization",
                "Manual scoring based on past interactions"
            ],
            type: "MCQs",
            correctAnswer: "Data Science Workspace to build and train a machine learning model using historical, behavioral, and transactional data"
        },
        {
            question: "In Adobe Experience Platform, which component is crucial for managing the structure of customer data from various sources?",
            choices: [
                "Real-time Customer Profile",
                "Data Science Workspace",
                "Adobe Experience Data Model (XDM)",
                "Adobe Experience Platform Launch"
            ],
            type: "MCQs",
            correctAnswer: "Adobe Experience Data Model (XDM)"
        },
        {
            question: "For integrating a new data source into Adobe Experience Platform, which sequence best represents the correct data flow?",
            choices: [
                "Direct ingestion into Real-time Customer Profile without pre-processing",
                "Mapping to XDM schemas, identity resolution, then ingestion into Real-time Customer Profile",
                "Loading data into Data Science Workspace first",
                "Integration via Adobe Experience Platform Launch without schema mapping"
            ],
            type: "MCQs",
            correctAnswer: "Mapping to XDM schemas, identity resolution, then ingestion into Real-time Customer Profile"
        },
        {
            question: "What architectural technique does Real-time Customer Profile use for low-latency access to unified customer data?",
            choices: [
                "Storing data in traditional relational databases",
                "In-memory database for fast retrieval",
                "Relying on batch processing",
                "File-based storage systems for profile data"
            ],
            type: "MCQs",
            correctAnswer: "In-memory database for fast retrieval"
        },
        {
            question: "How does the identity graph enhance customer profile accuracy in Adobe Experience Platform?",
            choices: [
                "Storing data in flat files",
                "Advanced algorithms to match and link multiple identifiers",
                "Avoiding identity resolution to prevent conflicts",
                "Storing only primary identifiers"
            ],
            type: "MCQs",
            correctAnswer: "Advanced algorithms to match and link multiple identifiers"
        },
        {
            question: "For a personalized marketing campaign, which architectural element is crucial for dynamic profile updates?",
            choices: [
                "Static data ingestion",
                "Real-time data connectors and event-based integration",
                "Monthly synchronization jobs",
                "Manual profile updates by marketing teams"
            ],
            type: "MCQs",
            correctAnswer: "Real-time data connectors and event-based integration"
        },
        {
            question: "Which advanced security feature ensures data privacy and compliance during CDP operations in Adobe Experience Platform?",
            choices: [
                "Plain text storage of sensitive data",
                "Role-based access control (RBAC) and encryption both at rest and in transit",
                "Disabling logging to avoid breaches",
                "Shared accounts for data access"
            ],
            type: "MCQs",
            correctAnswer: "Role-based access control (RBAC) and encryption both at rest and in transit"
        },
        {
            question: "What design principle does Adobe Experience Platform employ for high availability and scalability of CDP functionalities?",
            choices: [
                "Single server deployment",
                "Distributed architecture with load balancing and horizontal scaling",
                "Local data storage",
                "Manual scaling based on usage"
            ],
            type: "MCQs",
            correctAnswer: "Distributed architecture with load balancing and horizontal scaling"
        },
        {
            question: "In cross-channel customer engagement, which Adobe Experience Platform component ensures consistent messaging across channels?",
            choices: [
                "Data Governance",
                "Real-time Customer Profile with centralized segmentation",
                "Batch data processing",
                "Isolated data silos for each channel"
            ],
            type: "MCQs",
            correctAnswer: "Real-time Customer Profile with centralized segmentation"
        },
        {
            question: "What method is most effective for complex data transformations and enrichment before ingestion in Adobe Experience Platform?",
            choices: [
                "Manual data entry",
                "ETL processes with custom transformation logic",
                "Direct ingestion of raw data",
                "External data vendor processing"
            ],
            type: "MCQs",
            correctAnswer: "ETL processes with custom transformation logic"
        },
        {
            question: "For predictive analytics in Adobe Experience Platform, which combination provides the most comprehensive solution?",
            choices: [
                "Basic statistical analysis in Excel",
                "Data Science Workspace and Real-time Customer Profile for integrating predictive insights",
                "Manual predictions based on historical data",
                "Static models without customization"
            ],
            type: "MCQs",
            correctAnswer: "Data Science Workspace and Real-time Customer Profile for integrating predictive insights"
        },
        {
            question: "A retail company wants to launch a personalized email marketing campaign targeting customers who have browsed products online but haven't made a purchase. Which components of Adobe Experience Platform should be utilized to create and execute this campaign effectively?",
            choices: [
                "Use Real-time Customer Profile to segment the audience based on browsing behavior, and Adobe Campaign for email delivery.",
                "Use Adobe Audience Manager for segmentation and Adobe Analytics for email delivery",
                "Use Data Science Workspace for segmentation and Real-time Customer Profile for email delivery.",
                "Use Adobe Experience Platform Launch for segmentation and Adobe Audience Manager for email delivery."
            ],
            type: "MCQs",
            correctAnswer: "Use Real-time Customer Profile to segment the audience based on browsing behavior, and Adobe Campaign for email delivery."
        },
        {
            question: "A financial services company needs to comply with strict data privacy regulations, including GDPR and CCPA. They plan to integrate data from various sources into Adobe Experience Platform. Which practices and features should they implement to ensure compliance?",
            choices: [
                "Use manual data entry to control data accuracy and comply with regulations.",
                "Implement data anonymization and pseudonymization, role-based access control (RBAC), and automated data classification using Data Governance API.",
                "Store all data in plain text to simplify auditing processes.",
                "Disable data logging to prevent data breaches."
            ],
            type: "MCQs",
            correctAnswer: "Implement data anonymization and pseudonymization, role-based access control (RBAC), and automated data classification using Data Governance API."
        }
    ]
};

export default aepCdpArchitectQ;